(function () {
  const searchableFields = [
    'title',
    'body',
    'product_type',
    'tag',
    'variants.sku',
    'variants.title',
  ];

  function buildSearchQuery(terms) {
    const tokens = terms.trim().match(/"[^"]*"|\S+/g) || [];

    return tokens
      .map((token) => token.replace(/^"|"$/g, ''))
      .filter(Boolean)
      .map((token) => {
        const escapedToken = token
          .replace(/\\/g, '\\\\')
          .replace(/"/g, '\\"');
        const fieldQueries = searchableFields
          .map((field) => `${field}:"${escapedToken}"`)
          .join(' OR ');

        return `(${fieldQueries})`;
      })
      .join(' AND ');
  }

  function isScopedQuery(terms) {
    return terms.includes('title:') && terms.includes('variants.sku:');
  }

  window.GraystoneSearchFields = {
    buildQuery: buildSearchQuery,
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('[data-live-search-form]')) return;

    const termsInput = form.querySelector('[name="q"]');
    if (!termsInput || !termsInput.value.trim() || isScopedQuery(termsInput.value)) return;

    // Shopify's standard storefront search has no supported field-selection
    // parameter. Scope submitted terms explicitly so vendor and barcode are
    // excluded while customer-facing fields and variant SKU remain searchable.
    termsInput.value = buildSearchQuery(termsInput.value);
  }, true);
}());
